
export type MetricsExportRequestFormat = typeof MetricsExportRequestFormat[keyof typeof MetricsExportRequestFormat];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MetricsExportRequestFormat = {
  CSV: 'CSV',
  JSON: 'JSON',
  PDF: 'PDF',
} as const;
